import { render, staticRenderFns } from "./ContratoAtualizarApostilar.vue?vue&type=template&id=7588b653"
import script from "./ContratoAtualizarApostilar.vue?vue&type=script&lang=js"
export * from "./ContratoAtualizarApostilar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports